import { useSearchParams } from "react-router-dom";
import { useJourneyAuth } from "./auth/AuthContext";

export function useHubVisitor() {
  const [params] = useSearchParams();
  const { session } = useJourneyAuth();
  const role = params.get("role") || session?.role || "";
  const user = params.get("user") || session?.deskUserId || "";
  return {
    role,
    user,
    signedIn: Boolean(role || user),
    isAdmin: role === "admin",
  };
}

export function withVisitor(path, visitor) {
  const url = new URL(path, "https://dreamhomejourney.online");
  if (visitor?.role) url.searchParams.set("role", visitor.role);
  if (visitor?.user) url.searchParams.set("user", visitor.user);
  return `${url.pathname}${url.search}`;
}
